export default {
  'pwa.offline': 'Không có kết nối mạng',
  'pwa.serviceworker.updated': 'Nội dung cần tải lại',
  'pwa.serviceworker.updated.hint': 'Nhấn nút "Làm mới" để tải lại trang',
  'pwa.serviceworker.updated.ok': 'Làm mới',
};
